import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class SecurityService extends RLBaseService {

    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    getSecurityTree() {
        return this.toRLService<Models.ISecurityTreeNode>("/api/security/getsecuritytree").query().$promise;
    }

    testAclAccess(uri: string) {
        var data = {
            uri: uri
        };
        return this.toRLService<Models.ISecurityAccessResponse>("/api/security/testaclaccess").post(data).$promise;
    }

    testAclPermission(uri: string) {
        var data = {
            uri: uri
        };
        return this.toRLService<Models.ISecurityAccessResponse>("/api/security/testaclpermission").post(data).$promise;
    }

    generateSecurityTokens() {
        return this.toRLService<{ apiAuthID: string, accessKey: string, secretKey: string }>("/api/security/GenerateAccessTokens").post().$promise;
    }

    revokeSecurityTokens(authID: string) {
        return this.toRLService<void>("/api/security/RevokeAccessTokens").get({authID: authID}).$promise;
    }

    getSecurityTokens() {
        return this.toRLService<Models.IApiAuthKey>("/api/security/GetAccessTokens").getArray().$promise;
    }
}
